import { AutogenModelRouteDetails, AutogenRowRouteDetails } from "./autogen/AutogenModelRouteDetails";

export class ModelRouteDetails extends AutogenModelRouteDetails<RowRouteDetails> {
	constructor() {
		super(RowRouteDetails);
	}
}

export class RowRouteDetails extends AutogenRowRouteDetails {
}